__webpack_require__.p = "/Shri-Shyam-Decor/";